import { createContext } from 'react';

const VisOverrideContext = createContext();
VisOverrideContext.displayName = 'VisOverrideContext';

export default VisOverrideContext;
